export function getAbilityMod(ability: number) {
	const mod = Math.floor((ability - 10) / 2);
	const sign = mod >= 0;
	return (sign ? '+' : '−') + Math.abs(mod).toString();
}
